import { Icon } from "@iconify/react"
import "../css/fon.css"
import useGenStore from "../store/genstore";
import useFirebaseStore from "../store/firebasestore";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getAuth,signOut } from "firebase/auth";
import Swal from "sweetalert2";

function FonSideBar(){
        const fonView= useGenStore((s)=>s.fonView)
        const setFonView= useGenStore((s)=>s.setFonView)
        const authStatus = useFirebaseStore((s)=>s.authStatus)
        const isAdmin = useFirebaseStore((s)=>s.isAdmin)
        const navigate = useNavigate()
        const contactUs = () => {
  window.location.href = "tel:+254719140419";
};
   const logOut =()=>{
          Swal.fire({
                    title:"Are You Sure?",
                    text:"Please confirm you are signing out!",
                    icon:"question",
                    showConfirmButton:true,
                    confirmButtonText:"Log Out",
                    showCancelButton:true,
                    cancelButtonText:"Cancel",
                    cancelButtonColor:"#6a5acd"
                
                }).then((result)=>{
                    if(result.isConfirmed){
                    const auth = getAuth()
                    signOut(auth).then(()=>{
                        navigate("/auth")
                    }).catch(()=>{
                        Swal.fire("Error", "An error occured", "error")
                    })
                    }
                  
                })
    
      
    }
    
        useEffect(()=>{
           console.log(isAdmin)
        },[isAdmin])

    return(
        <div className={`fonSideBar ${fonView ? "fonSideBarActive": ""}`}>
            <div className="fonSBCont">
                <p onClick={()=>{
                     setFonView(false)
                    navigate("/")
                                               

                    }}>Home </p>
                <p onClick={()=>{
       setFonView(false)
                    navigate("/")

                }}>About Us </p>
                <p onClick={()=>{
                     setFonView(false)
                    navigate("/branding")}}>Create Label </p>
               
                <p onClick={()=>{
                          setFonView(false)
                    contactUs()
                    }}>Contact Us </p>
                    {isAdmin &&  <p onClick={()=>{
                     setFonView(false)

                    navigate("/admin")}}>Admin Panel </p>}

                    {authStatus ==="authenticated" ? ( 
                        <p onClick={()=>{
                     setFonView(false)

                    logOut()}}>Sign Out </p>):( <p onClick={()=>{
                     setFonView(false)

                    navigate("/auth")}}>Sign In </p>)}
                <div className="fonSBContCancel" onClick={()=>setFonView(false)}>
                    <Icon className="faIcon" icon="solar:alt-arrow-right-linear"/>
                </div>
            </div>
        </div>
    )
}
export default FonSideBar;